<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Only CTA:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"><i class="bi bi-trash-fill remove-block-icon"></i></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'OnlyCtaLink')"
            [blockData]="block.variables?.OnlyCtaLink ?? ''"
            [placeholder]="onlyCtaLinkPlaceholder"
            variable="OnlyCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'OnlyCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.OnlyCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-12 gy-3">
          <app-block-text
            [type]="'content'"
            [maxLength]="500"
            (handleOnChange)="onChange($event, 'OnlyCtaText')"
            [blockData]="block.variables?.OnlyCtaText ?? ''"
            [placeholder]="onlyCtaTextPlaceholder"
            variable="OnlyCtaText"
            [maxLength]="30"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-12 mt-2" *ngIf="block.variables?.OnlyCtaText">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.OnlyCtaLink))"
              target="_blank"
              [innerHTML]="$safeNavigationMigration(block.variables?.OnlyCtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
